import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Card from './Card'
import SearchForm from './SearchForm'
import CardForm from './CardForm'
import $ from 'jquery';

export default class Cards extends Component {

    componentDidMount() {
        if (this.props.session.authenticated === true) {
            this.props.getCards(this.props.user.isAdmin ? '' : this.props.user.companyId);
        }
    }

    onAddCardBtnClick(e) {
        $('#cardForm').modal({show: true, backdrop: 'static'});
        this.props.addCard(e);
    }

    onSubmitSuccess() {
        this.closeCardForm();
    }

    closeCardForm() {
        $('#cardForm').modal('hide');
    }

    onDeleteClick() {
        const id = $('#confirmationDialogId').val();
        this.props.deleteCard(id, this.props.user.isAdmin ? '' : this.props.user.companyId);
    }

    render() {
        const self = this;
        const cards = self.props.cards;

        let cardsTemplate;
        let numberOfCards = 0;
        if (cards && cards.length > 0) {
            numberOfCards = cards.length;
            cardsTemplate = cards.map(function (card, index) {
                return (
                    <Card key={index.toString()} card={card} editCard={self.props.editCard}
                            deleteCard={self.props.deleteCard}
                            action={self.props.action}
                            fetching={self.props.fetching}
                            user={self.props.user}
                            translations={self.props.translations}
                            />
                )
            })
        } else {
            cardsTemplate = <div className='not-found p-3'>Ei hakemuksia</div>
        }

        return (
            <div className=''>
                <div className='container-fluid'>
                    <div id='confirmationDialog' className='modal fade'>
                        <div className='modal-dialog modal-sm' role='document'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <h4><span id='confirmationDialogTitle'/></h4>
                                    <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-body'>
                                    <input id='confirmationDialogId' type='hidden' value='0'/>
                                    <div id='confirmationDialogText'/>
                                </div>
                                <div className='modal-footer'>
                                    <button className='btn btn-danger' id='confirmButton' onClick={::this.onDeleteClick}
                                            data-toggle='modal' data-target='#confirmationDialog'><span
                                        className='fa fa-trash-o'/> Delete
                                    </button>
                                    <button className='btn' data-dismiss='modal'>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CardForm card={this.props.card} saveCard={this.props.saveCard}
                            saveCardTemporarily={this.props.saveCardTemporarily}
                            editCardTimePeriod={this.props.editCardTimePeriod}
                            fetching={this.props.fetching}
                            deleteCard={this.props.deleteCard}
                            action={this.props.action} user={this.props.user}
                            onDeleteSuccess={::this.closeCardForm}
                            onSubmitSuccess={::this.onSubmitSuccess}
                            translations={this.props.translations}
                            />


                    {!this.props.user.isAdmin &&
                        <div>
                          <div id='addCardButton' className='row'>
                            <div className='col-sm-6 offset-sm-3'>
                              <button className='btn btn-primary btn-lg full-width'
                                      disabled={this.props.fetching}
                                      onClick={::this.onAddCardBtnClick}>
                                  <span className='fa fa-plus btn-icon'/>
                                  <span className='btn-text'>
                                    {this.props.translations['cardsPage.Uusi hakemus']}
                                  </span>
                              </button>
                            </div>
                          </div>
                          <hr/>
                        </div>
                    }
                    <SearchForm cards={this.props.cards} getCards={self.props.getCards}
                            searchCards={self.props.searchCards}
                            user={this.props.user}
                            translations={this.props.translations}
                            />
                    <hr/>
                    {/*<h5>Cards total: {numberOfCards}</h5>*/}

                    <div id='cardsTemplate' className='row'>
                        {cardsTemplate}
                    </div>

                    {/*<h5>Cards total: {numberOfCards}</h5>*/}
                </div>
            </div>
        );
    }
}

Cards.propTypes = {
    getCards: PropTypes.func,
    searchCards: PropTypes.func,
    saveCard: PropTypes.func,
    addCard: PropTypes.func,
    editCard: PropTypes.func,
    deleteCard: PropTypes.func,
    clearPage: PropTypes.func,
    translations: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Cards.js